/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Unika API
 * Insurance management API
 *
 * OpenAPI spec version: 2026-08-19 12:02
 * Contact: kundservice@unikaforsakringar.se
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as portableFetch from 'portable-fetch';
import * as url from 'url';
import { Configuration } from './configuration';

const BASE_PATH = 'http://localhost:3000'.replace(/\/+$/, '');

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|',
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration?: Configuration;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = portableFetch,
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name = 'RequiredError';
  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 *
 * @export
 * @interface Account
 */
export interface Account {
  /**
   *
   * @type {AccountBroker}
   * @memberof Account
   */
  broker?: AccountBroker;
  /**
   *
   * @type {Array<Broker>}
   * @memberof Account
   */
  brokers?: Array<Broker>;
  /**
   *
   * @type {Array<Account>}
   * @memberof Account
   */
  companies?: Array<Account>;
  /**
   *
   * @type {Date}
   * @memberof Account
   */
  created?: Date;
  /**
   *
   * @type {boolean}
   * @memberof Account
   */
  demo: boolean;
  /**
   *
   * @type {number}
   * @memberof Account
   */
  discount?: number;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  minHealthCheckupPaidFrom?: string;
  /**
   *
   * @type {Array<Order>}
   * @memberof Account
   */
  orders?: Array<Order>;
  /**
   *
   * @type {Array<PaymentMethod>}
   * @memberof Account
   */
  paymentMethods?: Array<PaymentMethod>;
  /**
   *
   * @type {Array<Product>}
   * @memberof Account
   */
  products?: Array<Product>;
  /**
   *
   * @type {Sensitive}
   * @memberof Account
   */
  sensitive?: Sensitive;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  status: Account.StatusEnum;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  type: Account.TypeEnum;
  /**
   *
   * @type {Date}
   * @memberof Account
   */
  updated?: Date;
}

/**
 * @export
 * @namespace Account
 */
export namespace Account {
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Active = 'active',
    Deleting = 'deleting',
    Deleted = 'deleted',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Person = 'person',
    Company = 'company',
  }
}

/**
 *
 * @export
 * @interface AccountBroker
 */
export interface AccountBroker {}

/**
 *
 * @export
 * @interface AccountSwitchResponse
 */
export interface AccountSwitchResponse {
  /**
   *
   * @type {string}
   * @memberof AccountSwitchResponse
   */
  token?: string;
}

/**
 *
 * @export
 * @interface AccountsReportPayload
 */
export interface AccountsReportPayload {
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  annuityLogic?: AccountsReportPayload.AnnuityLogicEnum;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  broker?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  endDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof AccountsReportPayload
   */
  isBDX?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AccountsReportPayload
   */
  isUnderwriting?: boolean;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  partner?: AccountsReportPayload.PartnerEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof AccountsReportPayload
   */
  productTypes?: Array<AccountsReportPayload.ProductTypesEnum>;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  simulatePricing?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportPayload
   */
  type: AccountsReportPayload.TypeEnum;
}

/**
 * @export
 * @namespace AccountsReportPayload
 */
export namespace AccountsReportPayload {
  /**
   * @export
   * @enum {string}
   */
  export enum AnnuityLogicEnum {
    V1 = 'v1',
    V2 = 'v2',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum PartnerEnum {
    Axis = 'axis',
    Aiu = 'aiu',
    Axeria = 'axeria',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypesEnum {
    HealthPlus = 'health_plus',
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Written = 'written',
    Paid = 'paid',
    PaidBdx = 'paidBdx',
    Renewed = 'renewed',
    WrittenAndRenewed = 'writtenAndRenewed',
  }
}

/**
 *
 * @export
 * @interface AccountsReportRow
 */
export interface AccountsReportRow {
  /**
   *
   * @type {boolean}
   * @memberof AccountsReportRow
   */
  addedAnnuity?: boolean;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  age?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  annualPrice: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  annualPriceForPeriod: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  birthday: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  brain?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  broker?: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  brokerCommission: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  brokerCommissionVAT: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  brokerCompanyName?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  brokerName?: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  brokerOrgCommission: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  brokerOrgCommissionVAT: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  cancellationDate?: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  cancer?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  chronic?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  created?: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  diabetes?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  discount: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  examinations?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  firstRiskFrom: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  frontingFees?: any;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  fullName: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  furtherCommission: any;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  gender?: AccountsReportRow.GenderEnum;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  groupPolicyType?: AccountsReportRow.GroupPolicyTypeEnum;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  heart?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  inGroup?: AccountsReportRow.InGroupEnum;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  index: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  initialDecision?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  insuredFrom: string;
  /**
   *
   * @type {boolean}
   * @memberof AccountsReportRow
   */
  isMain: boolean;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  leukemia?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  livesCount: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  locality: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  londonCommission: any;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  orderType: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  originalPrice?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  owner: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  paidDate?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  paidFrom: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  paidUntil: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  payer: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  payerActiveOrders?: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  payerAnnuityDate?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  payerName?: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  payerType?: AccountsReportRow.PayerTypeEnum;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  paymentPeriod?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  pendingTransactionsCount: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  policyholderRelationship?: AccountsReportRow.PolicyholderRelationshipEnum;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  postalCode: string;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  potentialCancer?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  productName?: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  reinsuranceBrokerage?: any;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  relationship?: AccountsReportRow.RelationshipEnum;
  /**
   *
   * @type {boolean}
   * @memberof AccountsReportRow
   */
  removedAnnuity?: boolean;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  riskFrom: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  riskPremium?: any;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  riskUntil: string;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  streetAddress: string;
  /**
   *
   * @type {any}
   * @memberof AccountsReportRow
   */
  tiedAgentCommission?: any;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  totalBrokerCommission: number;
  /**
   *
   * @type {string}
   * @memberof AccountsReportRow
   */
  transactionType: AccountsReportRow.TransactionTypeEnum;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  transactionsCount: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  tumor?: number;
  /**
   *
   * @type {number}
   * @memberof AccountsReportRow
   */
  unikaRevenue: number;
}

/**
 * @export
 * @namespace AccountsReportRow
 */
export namespace AccountsReportRow {
  /**
   * @export
   * @enum {string}
   */
  export enum GenderEnum {
    Male = 'Male',
    Female = 'Female',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum GroupPolicyTypeEnum {
    Single = 'single',
    SingleGroup = 'single_group',
    CoupleGroup = 'couple_group',
    SingleChildGroup = 'single_child_group',
    FamilyGroup = 'family_group',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum InGroupEnum {
    Group = 'Group',
    NoGroup = 'No Group',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum PayerTypeEnum {
    Written = 'written',
    Paid = 'paid',
    PaidBdx = 'paidBdx',
    Renewed = 'renewed',
    WrittenAndRenewed = 'writtenAndRenewed',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum PolicyholderRelationshipEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum RelationshipEnum {
    Main = 'main',
    Spouse = 'spouse',
    Child = 'child',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum TransactionTypeEnum {
    OP = 'OP',
    AP = 'AP',
    RP = 'RP',
    MRP = 'MRP',
    CANCEL = 'CANCEL',
  }
}

/**
 *
 * @export
 * @interface AddCompanyOwnerPayload
 */
export interface AddCompanyOwnerPayload {
  /**
   * Company account ID
   * @type {string}
   * @memberof AddCompanyOwnerPayload
   */
  companyId: string;
  /**
   * Person personnummer (12 digits)
   * @type {string}
   * @memberof AddCompanyOwnerPayload
   */
  personnummer: string;
}

/**
 *
 * @export
 * @interface AdminIssueDto
 */
export interface AdminIssueDto {
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  fullName: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  orderId?: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  token: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  transactionId?: string;
  /**
   *
   * @type {string}
   * @memberof AdminIssueDto
   */
  type: AdminIssueDto.TypeEnum;
}

/**
 * @export
 * @namespace AdminIssueDto
 */
export namespace AdminIssueDto {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    MissingPaymentMethod = 'missing_payment_method',
    PendingTransactionOverdue = 'pending_transaction_overdue',
  }
}

/**
 *
 * @export
 * @interface AuthPayload
 */
export interface AuthPayload {
  /**
   *
   * @type {string}
   * @memberof AuthPayload
   */
  personnummer?: string;
}

/**
 *
 * @export
 * @interface AuthRequest
 */
export interface AuthRequest {
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  autoStartToken?: string;
  /**
   *
   * @type {Date}
   * @memberof AuthRequest
   */
  created?: Date;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  error?: AuthRequest.ErrorEnum;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  hint?: AuthRequest.HintEnum;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  qr?: string;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  status: AuthRequest.StatusEnum;
  /**
   *
   * @type {string}
   * @memberof AuthRequest
   */
  token?: string;
  /**
   *
   * @type {Date}
   * @memberof AuthRequest
   */
  updated?: Date;
}

/**
 * @export
 * @namespace AuthRequest
 */
export namespace AuthRequest {
  /**
   * @export
   * @enum {string}
   */
  export enum ErrorEnum {
    Cancelled = 'cancelled',
    AlreadyInProgress = 'alreadyInProgress',
    RequestTimeout = 'requestTimeout',
    Maintenance = 'maintenance',
    InternalError = 'internalError',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum HintEnum {
    OutstandingTransaction = 'outstandingTransaction',
    NoClient = 'noClient',
    UserCancel = 'userCancel',
    ExpiredTransaction = 'expiredTransaction',
    UserSign = 'userSign',
    Started = 'started',
    CertificateErr = 'certificateErr',
    StartFailed = 'startFailed',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Pending = 'pending',
    Failed = 'failed',
    Complete = 'complete',
  }
}

/**
 *
 * @export
 * @interface BankRequest
 */
export interface BankRequest {
  /**
   *
   * @type {Array<BankRequestAccount>}
   * @memberof BankRequest
   */
  accounts?: Array<BankRequestAccount>;
  /**
   *
   * @type {string}
   * @memberof BankRequest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BankRequest
   */
  qr?: string;
  /**
   *
   * @type {string}
   * @memberof BankRequest
   */
  status: BankRequest.StatusEnum;
  /**
   *
   * @type {string}
   * @memberof BankRequest
   */
  token?: string;
}

/**
 * @export
 * @namespace BankRequest
 */
export namespace BankRequest {
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Waiting = 'Waiting',
    Success = 'Success',
    Failed = 'Failed',
  }
}

/**
 *
 * @export
 * @interface BankRequestAccount
 */
export interface BankRequestAccount {
  /**
   *
   * @type {string}
   * @memberof BankRequestAccount
   */
  account: string;
  /**
   *
   * @type {boolean}
   * @memberof BankRequestAccount
   */
  autogiro: boolean;
  /**
   *
   * @type {string}
   * @memberof BankRequestAccount
   */
  clearing: string;
  /**
   *
   * @type {string}
   * @memberof BankRequestAccount
   */
  name: string;
}

/**
 *
 * @export
 * @interface BankRequestPayload
 */
export interface BankRequestPayload {
  /**
   *
   * @type {string}
   * @memberof BankRequestPayload
   */
  bank: BankRequestPayload.BankEnum;
  /**
   *
   * @type {string}
   * @memberof BankRequestPayload
   */
  personnummer: string;
}

/**
 * @export
 * @namespace BankRequestPayload
 */
export namespace BankRequestPayload {
  /**
   * @export
   * @enum {string}
   */
  export enum BankEnum {
    OEB = 'OEB',
    SHB = 'SHB',
    ICA = 'ICA',
    LFB = 'LFB',
    NB = 'NB',
    SBAB = 'SBAB',
    SEB = 'SEB',
    SKB = 'SKB',
    SYD = 'SYD',
    FSPA = 'FSPA',
    FSPASB = 'FSPASB',
  }
}

/**
 *
 * @export
 * @interface Broker
 */
export interface Broker {
  /**
   *
   * @type {Array<Account>}
   * @memberof Broker
   */
  accounts?: Array<Account>;
  /**
   *
   * @type {string}
   * @memberof Broker
   */
  bankgiro?: string;
  /**
   *
   * @type {any}
   * @memberof Broker
   */
  brokerOrgCommissionOverride: any;
  /**
   *
   * @type {Array<Broker>}
   * @memberof Broker
   */
  children?: Array<Broker>;
  /**
   *
   * @type {any}
   * @memberof Broker
   */
  code: any;
  /**
   *
   * @type {string}
   * @memberof Broker
   */
  color?: string;
  /**
   *
   * @type {number}
   * @memberof Broker
   */
  commission: number;
  /**
   *
   * @type {Account}
   * @memberof Broker
   */
  company?: Account;
  /**
   *
   * @type {Date}
   * @memberof Broker
   */
  created?: Date;
  /**
   *
   * @type {Array<string>}
   * @memberof Broker
   */
  extraPricings?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof Broker
   */
  healthCheckupCommission: number;
  /**
   *
   * @type {string}
   * @memberof Broker
   */
  id: string;
  /**
   *
   * @type {boolean}
   * @memberof Broker
   */
  isOrg?: boolean;
  /**
   *
   * @type {string}
   * @memberof Broker
   */
  name: string;
  /**
   *
   * @type {Array<BrokerNotification>}
   * @memberof Broker
   */
  notifications?: Array<BrokerNotification>;
  /**
   *
   * @type {any}
   * @memberof Broker
   */
  oneTimeCashBonus: any;
  /**
   *
   * @type {Array<Account>}
   * @memberof Broker
   */
  owners?: Array<Account>;
  /**
   *
   * @type {Broker}
   * @memberof Broker
   */
  parent?: Broker;
  /**
   *
   * @type {Pricing}
   * @memberof Broker
   */
  pricing?: Pricing;
  /**
   *
   * @type {Date}
   * @memberof Broker
   */
  updated?: Date;
  /**
   *
   * @type {any}
   * @memberof Broker
   */
  utm?: any;
}

/**
 *
 * @export
 * @interface BrokerCustomers
 */
export interface BrokerCustomers {
  /**
   *
   * @type {Broker}
   * @memberof BrokerCustomers
   */
  broker?: Broker;
  /**
   *
   * @type {Array<BrokerCustomersPayer>}
   * @memberof BrokerCustomers
   */
  payers: Array<BrokerCustomersPayer>;
}

/**
 *
 * @export
 * @interface BrokerCustomersPayer
 */
export interface BrokerCustomersPayer {
  /**
   *
   * @type {Array<Order>}
   * @memberof BrokerCustomersPayer
   */
  orders: Array<Order>;
  /**
   *
   * @type {Account}
   * @memberof BrokerCustomersPayer
   */
  payer: Account;
}

/**
 *
 * @export
 * @interface BrokerInvite
 */
export interface BrokerInvite {
  /**
   *
   * @type {string}
   * @memberof BrokerInvite
   */
  token: string;
}

/**
 *
 * @export
 * @interface BrokerInvitePayload
 */
export interface BrokerInvitePayload {
  /**
   *
   * @type {string}
   * @memberof BrokerInvitePayload
   */
  brokerId?: string;
  /**
   *
   * @type {string}
   * @memberof BrokerInvitePayload
   */
  brokerOrg?: string;
  /**
   *
   * @type {number}
   * @memberof BrokerInvitePayload
   */
  commission: number;
  /**
   *
   * @type {Array<string>}
   * @memberof BrokerInvitePayload
   */
  extraPricings?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof BrokerInvitePayload
   */
  healthCheckupCommission: number;
  /**
   *
   * @type {string}
   * @memberof BrokerInvitePayload
   */
  pricing?: string;
}

/**
 *
 * @export
 * @interface BrokerMRR
 */
export interface BrokerMRR {
  /**
   *
   * @type {string}
   * @memberof BrokerMRR
   */
  brokerId?: string;
  /**
   *
   * @type {string}
   * @memberof BrokerMRR
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof BrokerMRR
   */
  lives: number;
  /**
   *
   * @type {number}
   * @memberof BrokerMRR
   */
  mrr: number;
  /**
   *
   * @type {number}
   * @memberof BrokerMRR
   */
  orders: number;
}

/**
 *
 * @export
 * @interface BrokerNotification
 */
export interface BrokerNotification {
  /**
   *
   * @type {string}
   * @memberof BrokerNotification
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof BrokerNotification
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BrokerNotification
   */
  type: BrokerNotification.TypeEnum;
}

/**
 * @export
 * @namespace BrokerNotification
 */
export namespace BrokerNotification {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Order = 'order',
    Report = 'report',
    Mislife = 'mislife',
  }
}

/**
 *
 * @export
 * @interface BrokerPayload
 */
export interface BrokerPayload {
  /**
   *
   * @type {string}
   * @memberof BrokerPayload
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof BrokerPayload
   */
  orgnummer: string;
  /**
   *
   * @type {string}
   * @memberof BrokerPayload
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof BrokerPayload
   */
  token?: string;
}

/**
 *
 * @export
 * @interface BrokerToAccountPayload
 */
export interface BrokerToAccountPayload {
  /**
   *
   * @type {string}
   * @memberof BrokerToAccountPayload
   */
  accountId: string;
  /**
   *
   * @type {string}
   * @memberof BrokerToAccountPayload
   */
  brokerId?: string;
}

/**
 *
 * @export
 * @interface ChangePayerPayload
 */
export interface ChangePayerPayload {
  /**
   *
   * @type {string}
   * @memberof ChangePayerPayload
   */
  orderId: string;
  /**
   *
   * @type {string}
   * @memberof ChangePayerPayload
   */
  personnummer: string;
}

/**
 *
 * @export
 * @interface CompanyOwnerResponse
 */
export interface CompanyOwnerResponse {
  /**
   *
   * @type {string}
   * @memberof CompanyOwnerResponse
   */
  fullName: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyOwnerResponse
   */
  hasActiveProductPaidByCompany: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyOwnerResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyOwnerResponse
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof CompanyOwnerResponse
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyOwnerResponse
   */
  type: string;
}

/**
 *
 * @export
 * @interface CompanyResponse
 */
export interface CompanyResponse {
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  fullName: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyResponse
   */
  hasActiveProducts: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  organisationsnummer: string;
  /**
   *
   * @type {Array<CompanyOwnerResponse>}
   * @memberof CompanyResponse
   */
  owners: Array<CompanyOwnerResponse>;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  type: string;
}

/**
 *
 * @export
 * @interface ConnectPaymentResponse
 */
export interface ConnectPaymentResponse {
  /**
   *
   * @type {string}
   * @memberof ConnectPaymentResponse
   */
  id?: string;
  /**
   *
   * @type {Account}
   * @memberof ConnectPaymentResponse
   */
  payer?: Account;
}

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse200
   */
  canRecreate?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  cancelledProductId?: string;
}

/**
 *
 * @export
 * @interface InlineResponse400
 */
export interface InlineResponse400 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse400
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse400
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse400
   */
  statusCode: number;
}

/**
 *
 * @export
 * @interface Lab
 */
export interface Lab {
  /**
   *
   * @type {string}
   * @memberof Lab
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof Lab
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof Lab
   */
  lat: number;
  /**
   *
   * @type {number}
   * @memberof Lab
   */
  lng: number;
  /**
   *
   * @type {string}
   * @memberof Lab
   */
  locality: string;
  /**
   *
   * @type {string}
   * @memberof Lab
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Lab
   */
  url: string;
}

/**
 *
 * @export
 * @interface MetricsPayload
 */
export interface MetricsPayload {
  /**
   *
   * @type {string}
   * @memberof MetricsPayload
   */
  productType?: MetricsPayload.ProductTypeEnum;
}

/**
 * @export
 * @namespace MetricsPayload
 */
export namespace MetricsPayload {
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypeEnum {
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
}

/**
 *
 * @export
 * @interface MislifePayload
 */
export interface MislifePayload {
  /**
   *
   * @type {Array<string>}
   * @memberof MislifePayload
   */
  productTypes?: Array<MislifePayload.ProductTypesEnum>;
}

/**
 * @export
 * @namespace MislifePayload
 */
export namespace MislifePayload {
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypesEnum {
    HealthPlus = 'health_plus',
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
}

/**
 *
 * @export
 * @interface ModelObject
 */
export interface ModelObject {}

/**
 *
 * @export
 * @interface MonthlyLives
 */
export interface MonthlyLives {
  /**
   *
   * @type {Date}
   * @memberof MonthlyLives
   */
  created?: Date;
  /**
   *
   * @type {Date}
   * @memberof MonthlyLives
   */
  updated?: Date;
}

/**
 *
 * @export
 * @interface MoveProductNote
 */
export interface MoveProductNote {
  /**
   *
   * @type {string}
   * @memberof MoveProductNote
   */
  code: MoveProductNote.CodeEnum;
  /**
   *
   * @type {string}
   * @memberof MoveProductNote
   */
  message: string;
  /**
   *
   * @type {any}
   * @memberof MoveProductNote
   */
  meta?: any;
}

/**
 * @export
 * @namespace MoveProductNote
 */
export namespace MoveProductNote {
  /**
   * @export
   * @enum {string}
   */
  export enum CodeEnum {
    ProductIsHealthCheckup = 'product_is_health_checkup',
    ProductNotMovable = 'product_not_movable',
    AccountUnavailable = 'account_unavailable',
    SameOrder = 'same_order',
    TargetNotFound = 'target_not_found',
    TargetAmbiguous = 'target_ambiguous',
    TargetIsHealthCheckup = 'target_is_health_checkup',
    AlreadyInsuredInTarget = 'already_insured_in_target',
    SourceMainPersonUnresolvable = 'source_main_person_unresolvable',
    TargetCannotTakeMoreAdults = 'target_cannot_take_more_adults',
    PendingInvoice = 'pending_invoice',
    CoverageOverlap = 'coverage_overlap',
    CoverageAlreadyPaidByTarget = 'coverage_already_paid_by_target',
    ArrearsBacklog = 'arrears_backlog',
    SourceOrderTypeChange = 'source_order_type_change',
    TargetOrderTypeChange = 'target_order_type_change',
    PayerChange = 'payer_change',
    BrokerChange = 'broker_change',
    PaymentPeriodChange = 'payment_period_change',
    SourceOrderLeftEmpty = 'source_order_left_empty',
    MidPeriodTopUp = 'mid_period_top_up',
    NoTopUpRaised = 'no_top_up_raised',
    PrepaidBeyondMove = 'prepaid_beyond_move',
    PricingResetToV1 = 'pricing_reset_to_v1',
  }
}

/**
 *
 * @export
 * @interface MoveProductPayload
 */
export interface MoveProductPayload {
  /**
   * Personal number of someone already insured in the package to move into
   * @type {string}
   * @memberof MoveProductPayload
   */
  personnummer?: string;
  /**
   * Product (insured person) to move
   * @type {string}
   * @memberof MoveProductPayload
   */
  productId: string;
  /**
   * Target package, when the personal number matches more than one
   * @type {string}
   * @memberof MoveProductPayload
   */
  targetOrderId?: string;
  /**
   * true = split out into a new package of its own
   * @type {boolean}
   * @memberof MoveProductPayload
   */
  toNewOrder: boolean;
}

/**
 *
 * @export
 * @interface MoveProductPreview
 */
export interface MoveProductPreview {
  /**
   *
   * @type {Array<MoveProductNote>}
   * @memberof MoveProductPreview
   */
  blockers: Array<MoveProductNote>;
  /**
   * Day the new package starts covering (split only)
   * @type {string}
   * @memberof MoveProductPreview
   */
  effectiveFrom?: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductPreview
   */
  insuredName: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductPreview
   */
  productId: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductPreview
   */
  sourceOrderId: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductPreview
   */
  sourcePaidUntil?: string;
  /**
   *
   * @type {MoveProductTarget}
   * @memberof MoveProductPreview
   */
  target?: MoveProductTarget;
  /**
   *
   * @type {Array<MoveProductNote>}
   * @memberof MoveProductPreview
   */
  warnings: Array<MoveProductNote>;
}

/**
 *
 * @export
 * @interface MoveProductTarget
 */
export interface MoveProductTarget {
  /**
   *
   * @type {Array<string>}
   * @memberof MoveProductTarget
   */
  members: Array<string>;
  /**
   *
   * @type {string}
   * @memberof MoveProductTarget
   */
  orderId: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductTarget
   */
  orderType?: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductTarget
   */
  paidUntil?: string;
  /**
   *
   * @type {string}
   * @memberof MoveProductTarget
   */
  payerName?: string;
}

/**
 *
 * @export
 * @interface Offer
 */
export interface Offer {
  /**
   *
   * @type {Account}
   * @memberof Offer
   */
  account?: Account;
  /**
   *
   * @type {Broker}
   * @memberof Offer
   */
  broker?: Broker;
  /**
   *
   * @type {Date}
   * @memberof Offer
   */
  created?: Date;
  /**
   *
   * @type {string}
   * @memberof Offer
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Offer
   */
  id?: string;
  /**
   *
   * @type {OrderPayload}
   * @memberof Offer
   */
  json?: OrderPayload;
  /**
   *
   * @type {AccountBroker}
   * @memberof Offer
   */
  order?: AccountBroker;
  /**
   *
   * @type {string}
   * @memberof Offer
   */
  personnummer?: string;
  /**
   *
   * @type {string}
   * @memberof Offer
   */
  phone?: string;
  /**
   *
   * @type {Pricing}
   * @memberof Offer
   */
  pricing?: Pricing;
  /**
   *
   * @type {Date}
   * @memberof Offer
   */
  sent?: Date;
  /**
   *
   * @type {string}
   * @memberof Offer
   */
  status: Offer.StatusEnum;
  /**
   *
   * @type {Date}
   * @memberof Offer
   */
  updated?: Date;
}

/**
 * @export
 * @namespace Offer
 */
export namespace Offer {
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    New = 'new',
    Sent = 'sent',
    Viewed = 'viewed',
    PersonsAdded = 'persons_added',
    PaymentAdded = 'payment_added',
    ConsentGiven = 'consent_given',
    OrderCreated = 'order_created',
    OrderCancelled = 'order_cancelled',
  }
}

/**
 *
 * @export
 * @interface Order
 */
export interface Order {
  /**
   *
   * @type {Date}
   * @memberof Order
   */
  created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Order
   */
  firstPaidFrom?: Date;
  /**
   *
   * @type {string}
   * @memberof Order
   */
  id: string;
  /**
   *
   * @type {any}
   * @memberof Order
   */
  invoiceReference?: any;
  /**
   *
   * @type {Date}
   * @memberof Order
   */
  lastPaidUntil?: Date;
  /**
   *
   * @type {Date}
   * @memberof Order
   */
  latestWrittenRenewedDate?: Date;
  /**
   *
   * @type {Pricing}
   * @memberof Order
   */
  mainPricing?: Pricing;
  /**
   *
   * @type {Account}
   * @memberof Order
   */
  owner: Account;
  /**
   *
   * @type {Account}
   * @memberof Order
   */
  payer: Account;
  /**
   *
   * @type {number}
   * @memberof Order
   */
  paymentPeriod?: number;
  /**
   *
   * @type {number}
   * @memberof Order
   */
  price?: number;
  /**
   *
   * @type {ProductPricing}
   * @memberof Order
   */
  pricing?: ProductPricing;
  /**
   *
   * @type {Array<Product>}
   * @memberof Order
   */
  products: Array<Product>;
  /**
   *
   * @type {Array<PaymentTransaction>}
   * @memberof Order
   */
  transactions: Array<PaymentTransaction>;
  /**
   *
   * @type {string}
   * @memberof Order
   */
  type?: Order.TypeEnum;
  /**
   *
   * @type {Date}
   * @memberof Order
   */
  updated?: Date;
}

/**
 * @export
 * @namespace Order
 */
export namespace Order {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Single = 'single',
    Couple = 'couple',
    SingleChild = 'single_child',
    Family = 'family',
  }
}

/**
 *
 * @export
 * @interface OrderChurn
 */
export interface OrderChurn {
  /**
   *
   * @type {string}
   * @memberof OrderChurn
   */
  cancelled: string;
  /**
   *
   * @type {string}
   * @memberof OrderChurn
   */
  created: string;
  /**
   *
   * @type {string}
   * @memberof OrderChurn
   */
  orderId: string;
}

/**
 *
 * @export
 * @interface OrderOptionsPayload
 */
export interface OrderOptionsPayload {
  /**
   *
   * @type {string}
   * @memberof OrderOptionsPayload
   */
  invoiceReference?: string;
  /**
   *
   * @type {string}
   * @memberof OrderOptionsPayload
   */
  payer?: string;
  /**
   *
   * @type {number}
   * @memberof OrderOptionsPayload
   */
  paymentPeriod?: number;
}

/**
 *
 * @export
 * @interface OrderPayload
 */
export interface OrderPayload {
  /**
   *
   * @type {string}
   * @memberof OrderPayload
   */
  brokerId?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrderPayload
   */
  consent?: boolean;
  /**
   *
   * @type {ProductMetaData}
   * @memberof OrderPayload
   */
  meta?: ProductMetaData;
  /**
   *
   * @type {string}
   * @memberof OrderPayload
   */
  offerId?: string;
  /**
   *
   * @type {PaymentPayload}
   * @memberof OrderPayload
   */
  paymentMethod?: PaymentPayload;
  /**
   *
   * @type {number}
   * @memberof OrderPayload
   */
  paymentPeriod?: number;
  /**
   *
   * @type {Array<Person>}
   * @memberof OrderPayload
   */
  persons: Array<Person>;
  /**
   *
   * @type {string}
   * @memberof OrderPayload
   */
  pricingId?: string;
  /**
   *
   * @type {string}
   * @memberof OrderPayload
   */
  productType?: OrderPayload.ProductTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OrderPayload
   */
  startDate?: string;
}

/**
 * @export
 * @namespace OrderPayload
 */
export namespace OrderPayload {
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypeEnum {
    HealthPlus = 'health_plus',
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
}

/**
 *
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
  /**
   *
   * @type {Date}
   * @memberof PaymentMethod
   */
  created?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  gateway: PaymentMethod.GatewayEnum;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  methodId: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  status: PaymentMethod.StatusEnum;
  /**
   *
   * @type {Array<PaymentTransaction>}
   * @memberof PaymentMethod
   */
  transactions: Array<PaymentTransaction>;
  /**
   *
   * @type {Date}
   * @memberof PaymentMethod
   */
  updated?: Date;
}

/**
 * @export
 * @namespace PaymentMethod
 */
export namespace PaymentMethod {
  /**
   * @export
   * @enum {string}
   */
  export enum GatewayEnum {
    Trustly = 'trustly',
    Billecta = 'billecta',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Active = 'active',
    Inactive = 'inactive',
    Pending = 'pending',
    Cancelled = 'cancelled',
  }
}

/**
 *
 * @export
 * @interface PaymentPayload
 */
export interface PaymentPayload {
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  account?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  bank?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  clearing?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  fullName?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  locality?: string;
  /**
   *
   * @type {any}
   * @memberof PaymentPayload
   */
  manual?: any;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentPayload
   */
  streetAddress?: string;
}

/**
 *
 * @export
 * @interface PaymentTransaction
 */
export interface PaymentTransaction {
  /**
   *
   * @type {number}
   * @memberof PaymentTransaction
   */
  amount: number;
  /**
   *
   * @type {Date}
   * @memberof PaymentTransaction
   */
  created?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  gatewayId?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  gatewayResponse?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof PaymentTransaction
   */
  paid: Date;
  /**
   *
   * @type {Date}
   * @memberof PaymentTransaction
   */
  paidFrom: Date;
  /**
   *
   * @type {Date}
   * @memberof PaymentTransaction
   */
  paidUntil: Date;
  /**
   *
   * @type {PaymentMethod}
   * @memberof PaymentTransaction
   */
  paymentMethod?: PaymentMethod;
  /**
   *
   * @type {number}
   * @memberof PaymentTransaction
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof PaymentTransaction
   */
  status?: PaymentTransaction.StatusEnum;
  /**
   *
   * @type {Date}
   * @memberof PaymentTransaction
   */
  updated?: Date;
}

/**
 * @export
 * @namespace PaymentTransaction
 */
export namespace PaymentTransaction {
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Pending = 'pending',
    Success = 'success',
    Failure = 'failure',
  }
}

/**
 *
 * @export
 * @interface Person
 */
export interface Person {
  /**
   *
   * @type {string}
   * @memberof Person
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  personnummer?: string;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  phone?: string;
  /**
   *
   * @type {Quiz}
   * @memberof Person
   */
  quiz?: Quiz;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  type: Person.TypeEnum;
}

/**
 * @export
 * @namespace Person
 */
export namespace Person {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Main = 'main',
    Spouse = 'spouse',
    Child = 'child',
  }
}

/**
 *
 * @export
 * @interface Pricing
 */
export interface Pricing {
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  commissionOverride?: number;
  /**
   *
   * @type {Date}
   * @memberof Pricing
   */
  created?: Date;
  /**
   *
   * @type {ProductPricing}
   * @memberof Pricing
   */
  health: ProductPricing;
  /**
   *
   * @type {ProductPricing}
   * @memberof Pricing
   */
  health_checkup: ProductPricing;
  /**
   *
   * @type {ProductPricing}
   * @memberof Pricing
   */
  health_plus: ProductPricing;
  /**
   *
   * @type {string}
   * @memberof Pricing
   */
  id: string;
  /**
   *
   * @type {Date}
   * @memberof Pricing
   */
  updated?: Date;
  /**
   *
   * @type {string}
   * @memberof Pricing
   */
  utm?: string;
}

/**
 *
 * @export
 * @interface PricingPayload
 */
export interface PricingPayload {
  /**
   *
   * @type {number}
   * @memberof PricingPayload
   */
  commissionOverride?: number;
  /**
   *
   * @type {ProductPricingPayload}
   * @memberof PricingPayload
   */
  health: ProductPricingPayload;
  /**
   *
   * @type {ProductPricingPayload}
   * @memberof PricingPayload
   */
  health_checkup: ProductPricingPayload;
  /**
   *
   * @type {ProductPricingPayload}
   * @memberof PricingPayload
   */
  health_plus: ProductPricingPayload;
  /**
   *
   * @type {string}
   * @memberof PricingPayload
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PricingPayload
   */
  utm?: string;
}

/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   *
   * @type {Account}
   * @memberof Product
   */
  account?: Account;
  /**
   * Health checkup analysis results keyed by HealthCheckupAnalysis
   * @type {{ [key: string]: string; }}
   * @memberof Product
   */
  analysis: { [key: string]: string };
  /**
   *
   * @type {Array<string>}
   * @memberof Product
   */
  availableTreatments?: Array<Product.AvailableTreatmentsEnum>;
  /**
   *
   * @type {Date}
   * @memberof Product
   */
  created?: Date;
  /**
   *
   * @type {boolean}
   * @memberof Product
   */
  hideFromUI?: boolean;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  id: string;
  /**
   *
   * @type {ProductMetaData}
   * @memberof Product
   */
  meta?: ProductMetaData;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  nextRenewal?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  note?: string;
  /**
   *
   * @type {Order}
   * @memberof Product
   */
  order?: Order;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  paidFrom?: string;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  paidUntil?: string;
  /**
   *
   * @type {Quiz}
   * @memberof Product
   */
  quiz: Quiz;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  status: Product.StatusEnum;
  /**
   *
   * @type {Array<PaymentTransaction>}
   * @memberof Product
   */
  transactions: Array<PaymentTransaction>;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  type: Product.TypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof Product
   */
  unavailableTreatments?: Array<Product.UnavailableTreatmentsEnum>;
  /**
   *
   * @type {Date}
   * @memberof Product
   */
  updated?: Date;
}

/**
 * @export
 * @namespace Product
 */
export namespace Product {
  /**
   * @export
   * @enum {string}
   */
  export enum AnalysisEnum {
    HeartVessels = 'heart_vessels',
    ThyroidGland = 'thyroid_gland',
    Diabetes = 'diabetes',
    VitaminsMinerals = 'vitamins_minerals',
    Liver = 'liver',
    Renal = 'renal',
    Blood = 'blood',
    Inflammation = 'inflammation',
    BloodPressure = 'blood_pressure',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum AvailableTreatmentsEnum {
    Cancer = 'cancer',
    Coronary = 'coronary',
    HeartValve = 'heart_valve',
    Neurosurgery = 'neurosurgery',
    Intracranial = 'intracranial',
    Organ = 'organ',
    Bone = 'bone',
    HeartVessels = 'heart_vessels',
    ThyroidGland = 'thyroid_gland',
    Diabetes = 'diabetes',
    VitaminsMinerals = 'vitamins_minerals',
    Liver = 'liver',
    Renal = 'renal',
    Blood = 'blood',
    Inflammation = 'inflammation',
    BloodPressure = 'blood_pressure',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Pending = 'pending',
    Active = 'active',
    Inactive = 'inactive',
    Cancelled = 'cancelled',
    Completed = 'completed',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    HealthPlus = 'health_plus',
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum UnavailableTreatmentsEnum {
    Cancer = 'cancer',
    Coronary = 'coronary',
    HeartValve = 'heart_valve',
    Neurosurgery = 'neurosurgery',
    Intracranial = 'intracranial',
    Organ = 'organ',
    Bone = 'bone',
    HeartVessels = 'heart_vessels',
    ThyroidGland = 'thyroid_gland',
    Diabetes = 'diabetes',
    VitaminsMinerals = 'vitamins_minerals',
    Liver = 'liver',
    Renal = 'renal',
    Blood = 'blood',
    Inflammation = 'inflammation',
    BloodPressure = 'blood_pressure',
  }
}

/**
 *
 * @export
 * @interface ProductMetaData
 */
export interface ProductMetaData {
  /**
   *
   * @type {string}
   * @memberof ProductMetaData
   */
  city?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductMetaData
   */
  ppsa?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductMetaData
   */
  pressure?: boolean;
}

/**
 *
 * @export
 * @interface ProductPayload
 */
export interface ProductPayload {
  /**
   *
   * @type {string}
   * @memberof ProductPayload
   */
  owner: string;
  /**
   *
   * @type {string}
   * @memberof ProductPayload
   */
  personnummer?: string;
  /**
   *
   * @type {string}
   * @memberof ProductPayload
   */
  productType: string;
  /**
   *
   * @type {string}
   * @memberof ProductPayload
   */
  quiz: string;
}

/**
 *
 * @export
 * @interface ProductPricing
 */
export interface ProductPricing {
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricing
   */
  couple: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricing
   */
  family: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricing
   */
  single: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricing
   */
  single_child: { [key: string]: number };
}

/**
 *
 * @export
 * @interface ProductPricingPayload
 */
export interface ProductPricingPayload {
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricingPayload
   */
  couple: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricingPayload
   */
  family: { [key: string]: number };
  /**
   *
   * @type {string}
   * @memberof ProductPricingPayload
   */
  id?: string;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricingPayload
   */
  single: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ProductPricingPayload
   */
  single_child: { [key: string]: number };
}

/**
 *
 * @export
 * @interface Quiz
 */
export interface Quiz {
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  age?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof Quiz
   */
  availableTreatments?: Array<Quiz.AvailableTreatmentsEnum>;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  brain?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  cancer?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  chronic?: number;
  /**
   *
   * @type {Date}
   * @memberof Quiz
   */
  created?: Date;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  diabetes?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  examinations?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  heart?: number;
  /**
   *
   * @type {string}
   * @memberof Quiz
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  leukemia?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  needInsurance?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  needInternational?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  needLeadingDoctors?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  needResult?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  needSecondOpinion?: number;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  potentialCancer?: number;
  /**
   *
   * @type {Pricing}
   * @memberof Quiz
   */
  pricing?: Pricing;
  /**
   *
   * @type {Array<string>}
   * @memberof Quiz
   */
  productTypes: Array<Quiz.ProductTypesEnum>;
  /**
   *
   * @type {number}
   * @memberof Quiz
   */
  tumor?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof Quiz
   */
  unavailableTreatments?: Array<Quiz.UnavailableTreatmentsEnum>;
  /**
   *
   * @type {Date}
   * @memberof Quiz
   */
  updated?: Date;
}

/**
 * @export
 * @namespace Quiz
 */
export namespace Quiz {
  /**
   * @export
   * @enum {string}
   */
  export enum AvailableTreatmentsEnum {
    Cancer = 'cancer',
    Coronary = 'coronary',
    HeartValve = 'heart_valve',
    Neurosurgery = 'neurosurgery',
    Intracranial = 'intracranial',
    Organ = 'organ',
    Bone = 'bone',
    HeartVessels = 'heart_vessels',
    ThyroidGland = 'thyroid_gland',
    Diabetes = 'diabetes',
    VitaminsMinerals = 'vitamins_minerals',
    Liver = 'liver',
    Renal = 'renal',
    Blood = 'blood',
    Inflammation = 'inflammation',
    BloodPressure = 'blood_pressure',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypesEnum {
    HealthPlus = 'health_plus',
    Health = 'health',
    HealthCheckup = 'health_checkup',
  }
  /**
   * @export
   * @enum {string}
   */
  export enum UnavailableTreatmentsEnum {
    Cancer = 'cancer',
    Coronary = 'coronary',
    HeartValve = 'heart_valve',
    Neurosurgery = 'neurosurgery',
    Intracranial = 'intracranial',
    Organ = 'organ',
    Bone = 'bone',
    HeartVessels = 'heart_vessels',
    ThyroidGland = 'thyroid_gland',
    Diabetes = 'diabetes',
    VitaminsMinerals = 'vitamins_minerals',
    Liver = 'liver',
    Renal = 'renal',
    Blood = 'blood',
    Inflammation = 'inflammation',
    BloodPressure = 'blood_pressure',
  }
}

/**
 *
 * @export
 * @interface QuizInvite
 */
export interface QuizInvite {
  /**
   *
   * @type {string}
   * @memberof QuizInvite
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof QuizInvite
   */
  personnummer: string;
}

/**
 *
 * @export
 * @interface RecreateHealthCheckupPayload
 */
export interface RecreateHealthCheckupPayload {
  /**
   * The account ID of the person whose health checkup should be recreated
   * @type {string}
   * @memberof RecreateHealthCheckupPayload
   */
  accountId: string;
}

/**
 *
 * @export
 * @interface RemoveCompanyOwnersPayload
 */
export interface RemoveCompanyOwnersPayload {
  /**
   * Company account ID
   * @type {string}
   * @memberof RemoveCompanyOwnersPayload
   */
  companyId: string;
  /**
   * Array of person account IDs to remove
   * @type {Array<string>}
   * @memberof RemoveCompanyOwnersPayload
   */
  ownerIds: Array<string>;
}

/**
 *
 * @export
 * @interface Sensitive
 */
export interface Sensitive {
  /**
   *
   * @type {Account}
   * @memberof Sensitive
   */
  account?: Account;
  /**
   *
   * @type {Date}
   * @memberof Sensitive
   */
  created?: Date;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  fullName: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  locality: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  personnummer: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof Sensitive
   */
  streetAddress: string;
  /**
   *
   * @type {Date}
   * @memberof Sensitive
   */
  updated?: Date;
}

/**
 *
 * @export
 * @interface SensitiveLookupPayload
 */
export interface SensitiveLookupPayload {
  /**
   *
   * @type {string}
   * @memberof SensitiveLookupPayload
   */
  nummer: string;
  /**
   *
   * @type {string}
   * @memberof SensitiveLookupPayload
   */
  type?: SensitiveLookupPayload.TypeEnum;
}

/**
 * @export
 * @namespace SensitiveLookupPayload
 */
export namespace SensitiveLookupPayload {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Person = 'person',
    Company = 'company',
  }
}

/**
 *
 * @export
 * @interface SensitiveUpdatePayload
 */
export interface SensitiveUpdatePayload {
  /**
   *
   * @type {string}
   * @memberof SensitiveUpdatePayload
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof SensitiveUpdatePayload
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SensitiveUpdatePayload
   */
  phone?: string;
}

/**
 * AccountApi - fetch parameter creator
 * @export
 */
export const AccountApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Download GDPR-compliant personal data archive
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerExport(token: string, options: any = {}): FetchArgs {
      // verify required parameter 'token' is not null or undefined
      if (token === null || token === undefined) {
        throw new RequiredError(
          'token',
          'Required parameter token was null or undefined when calling accountControllerExport.',
        );
      }
      const localVarPath = `/account/gdpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (token !== undefined) {
        localVarQueryParameter['token'] = token;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve current account and associated data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGet(options: any = {}): FetchArgs {
      const localVarPath = `/account`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStartDeleting(options: any = {}): FetchArgs {
      const localVarPath = `/account/gdpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stop account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStopDeleting(options: any = {}): FetchArgs {
      const localVarPath = `/account/gdpr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Switch to associated account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerSwitch(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling accountControllerSwitch.',
        );
      }
      const localVarPath = `/account/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Download GDPR-compliant personal data archive
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerExport(
      token: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AccountApiFetchParamCreator(
        configuration,
      ).accountControllerExport(token, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Retrieve current account and associated data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGet(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Account> {
      const localVarFetchArgs =
        AccountApiFetchParamCreator(configuration).accountControllerGet(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Start account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStartDeleting(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        AccountApiFetchParamCreator(
          configuration,
        ).accountControllerStartDeleting(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Stop account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStopDeleting(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        AccountApiFetchParamCreator(
          configuration,
        ).accountControllerStopDeleting(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Switch to associated account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerSwitch(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AccountSwitchResponse> {
      const localVarFetchArgs = AccountApiFetchParamCreator(
        configuration,
      ).accountControllerSwitch(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Download GDPR-compliant personal data archive
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerExport(token: string, options?: any) {
      return AccountApiFp(configuration).accountControllerExport(
        token,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Retrieve current account and associated data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGet(options?: any) {
      return AccountApiFp(configuration).accountControllerGet(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Start account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStartDeleting(options?: any) {
      return AccountApiFp(configuration).accountControllerStartDeleting(
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Stop account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStopDeleting(options?: any) {
      return AccountApiFp(configuration).accountControllerStopDeleting(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Switch to associated account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerSwitch(id: string, options?: any) {
      return AccountApiFp(configuration).accountControllerSwitch(id, options)(
        fetch,
        basePath,
      );
    },
  };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
  /**
   *
   * @summary Download GDPR-compliant personal data archive
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  public accountControllerExport(token: string, options?: any) {
    return AccountApiFp(this.configuration).accountControllerExport(
      token,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Retrieve current account and associated data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  public accountControllerGet(options?: any) {
    return AccountApiFp(this.configuration).accountControllerGet(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Start account deletion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  public accountControllerStartDeleting(options?: any) {
    return AccountApiFp(this.configuration).accountControllerStartDeleting(
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Stop account deletion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  public accountControllerStopDeleting(options?: any) {
    return AccountApiFp(this.configuration).accountControllerStopDeleting(
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Switch to associated account
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  public accountControllerSwitch(id: string, options?: any) {
    return AccountApiFp(this.configuration).accountControllerSwitch(
      id,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * AdminApi - fetch parameter creator
 * @export
 */
export const AdminApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Add person as company owner
     * @param {AddCompanyOwnerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAddCompanyOwner(
      body: AddCompanyOwnerPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerAddCompanyOwner.',
        );
      }
      const localVarPath = `/admin/companies/owner`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'AddCompanyOwnerPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Assign broker to account
     * @param {BrokerToAccountPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAssignBrokerToAccount(
      body: BrokerToAccountPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerAssignBrokerToAccount.',
        );
      }
      const localVarPath = `/admin/brokers/accounts`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'BrokerToAccountPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns true if the account has a cancelled health checkup and no active/pending/inactive ones
     * @summary Check if health checkup can be recreated for an account
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerCanRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerCanRecreateHealthCheckup.',
        );
      }
      const localVarPath = `/admin/healthcheckup/can-recreate`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'RecreateHealthCheckupPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Change order payer
     * @param {ChangePayerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerChangePayer(
      body: ChangePayerPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerChangePayer.',
        );
      }
      const localVarPath = `/admin/order`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'ChangePayerPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteBroker(body: Broker, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerDeleteBroker.',
        );
      }
      const localVarPath = `/admin/brokers`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'Broker' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteOffer(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling adminControllerDeleteOffer.',
        );
      }
      const localVarPath = `/admin/offer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate accounts report
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReport(
      body: AccountsReportPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGenerateReport.',
        );
      }
      const localVarPath = `/admin/accounts/report`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'AccountsReportPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export accounts as MIS Life XML
     * @param {MislifePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLife(
      body: MislifePayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGenerateReportMISLife.',
        );
      }
      const localVarPath = `/admin/accounts/report/mislife`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'MislifePayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export broker company accounts as MIS Life XML archive
     * @param {string} brokerCompanyId
     * @param {Array<string>} productTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLifeArchive(
      brokerCompanyId: string,
      productTypes: Array<string>,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'brokerCompanyId' is not null or undefined
      if (brokerCompanyId === null || brokerCompanyId === undefined) {
        throw new RequiredError(
          'brokerCompanyId',
          'Required parameter brokerCompanyId was null or undefined when calling adminControllerGenerateReportMISLifeArchive.',
        );
      }
      // verify required parameter 'productTypes' is not null or undefined
      if (productTypes === null || productTypes === undefined) {
        throw new RequiredError(
          'productTypes',
          'Required parameter productTypes was null or undefined when calling adminControllerGenerateReportMISLifeArchive.',
        );
      }
      const localVarPath =
        `/admin/accounts/report/mislife/{brokerCompanyId}`.replace(
          `{${'brokerCompanyId'}}`,
          encodeURIComponent(String(brokerCompanyId)),
        );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (productTypes) {
        localVarQueryParameter['productTypes'] = productTypes;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export accounts report as XLS
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportXLS(
      body: AccountsReportPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGenerateReportXLS.',
        );
      }
      const localVarPath = `/admin/accounts/report/xls`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'AccountsReportPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all accounts data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetAccounts(options: any = {}): FetchArgs {
      const localVarPath = `/admin/accounts`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all brokers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokers(options: any = {}): FetchArgs {
      const localVarPath = `/admin/brokers`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get invite for brokers
     * @param {BrokerInvitePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokersInvite(
      body: BrokerInvitePayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGetBrokersInvite.',
        );
      }
      const localVarPath = `/admin/brokers/invite`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'BrokerInvitePayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetChurn(
      body: MetricsPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGetChurn.',
        );
      }
      const localVarPath = `/admin/metrics/churn`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'MetricsPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all companies with owners and active product flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetCompanies(options: any = {}): FetchArgs {
      const localVarPath = `/admin/companies`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List operational issues for admin review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetIssues(options: any = {}): FetchArgs {
      const localVarPath = `/admin/issues`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMRR(body: MetricsPayload, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerGetMRR.',
        );
      }
      const localVarPath = `/admin/metrics/mrr`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'MetricsPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMonthlyLives(options: any = {}): FetchArgs {
      const localVarPath = `/admin/metrics/monthly-lives`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetOffers(options: any = {}): FetchArgs {
      const localVarPath = `/admin/offer`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all pricings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetPricings(options: any = {}): FetchArgs {
      const localVarPath = `/admin/pricing`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List brokers and customers
     * @param {'health' | 'health_checkup'} [productType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerListBrokerCustomers(
      productType?: 'health' | 'health_checkup',
      options: any = {},
    ): FetchArgs {
      const localVarPath = `/admin/accounts/customers`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (productType !== undefined) {
        localVarQueryParameter['productType'] = productType;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Move an insured person to another package, or split them out
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerMoveProduct(
      body: MoveProductPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerMoveProduct.',
        );
      }
      const localVarPath = `/admin/order/product/move`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'MoveProductPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Dry-run moving an insured person to another package
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerPreviewMoveProduct(
      body: MoveProductPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerPreviewMoveProduct.',
        );
      }
      const localVarPath = `/admin/order/product/move/preview`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'MoveProductPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a new health checkup order and product based on the latest cancelled health checkup for the given account
     * @summary Recreate health checkup from cancelled product
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerRecreateHealthCheckup.',
        );
      }
      const localVarPath = `/admin/healthcheckup/recreate`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'RecreateHealthCheckupPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Batch remove owners from a company
     * @param {RemoveCompanyOwnersPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRemoveCompanyOwners(
      body: RemoveCompanyOwnersPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerRemoveCompanyOwners.',
        );
      }
      const localVarPath = `/admin/companies/owners`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'RemoveCompanyOwnersPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveBroker(body: Broker, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerSaveBroker.',
        );
      }
      const localVarPath = `/admin/brokers`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'Broker' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save offer
     * @param {Offer} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveOffer(body: Offer, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerSaveOffer.',
        );
      }
      const localVarPath = `/admin/offer`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'Offer' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save pricing
     * @param {PricingPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSavePricing(
      body: PricingPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling adminControllerSavePricing.',
        );
      }
      const localVarPath = `/admin/pricing`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'PricingPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add person as company owner
     * @param {AddCompanyOwnerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAddCompanyOwner(
      body: AddCompanyOwnerPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyResponse> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerAddCompanyOwner(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Assign broker to account
     * @param {BrokerToAccountPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAssignBrokerToAccount(
      body: BrokerToAccountPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerAssignBrokerToAccount(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Returns true if the account has a cancelled health checkup and no active/pending/inactive ones
     * @summary Check if health checkup can be recreated for an account
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerCanRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerCanRecreateHealthCheckup(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Change order payer
     * @param {ChangePayerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerChangePayer(
      body: ChangePayerPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerChangePayer(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteBroker(
      body: Broker,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerDeleteBroker(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Delete offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteOffer(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerDeleteOffer(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Generate accounts report
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReport(
      body: AccountsReportPayload,
      options?: any,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<Array<AccountsReportRow>> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGenerateReport(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Export accounts as MIS Life XML
     * @param {MislifePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLife(
      body: MislifePayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGenerateReportMISLife(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Export broker company accounts as MIS Life XML archive
     * @param {string} brokerCompanyId
     * @param {Array<string>} productTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLifeArchive(
      brokerCompanyId: string,
      productTypes: Array<string>,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGenerateReportMISLifeArchive(
        brokerCompanyId,
        productTypes,
        options,
      );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Export accounts report as XLS
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportXLS(
      body: AccountsReportPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGenerateReportXLS(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary List all accounts data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetAccounts(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Account>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetAccounts(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary List all brokers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokers(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Broker>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetBrokers(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get invite for brokers
     * @param {BrokerInvitePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokersInvite(
      body: BrokerInvitePayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BrokerInvite> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGetBrokersInvite(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetChurn(
      body: MetricsPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<OrderChurn>> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGetChurn(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary List all companies with owners and active product flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetCompanies(
      options?: any,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<Array<CompanyResponse>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetCompanies(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary List operational issues for admin review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetIssues(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdminIssueDto>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetIssues(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMRR(
      body: MetricsPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<BrokerMRR>> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerGetMRR(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMonthlyLives(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MonthlyLives>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetMonthlyLives(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetOffers(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Offer>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetOffers(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all pricings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetPricings(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Pricing>> {
      const localVarFetchArgs =
        AdminApiFetchParamCreator(configuration).adminControllerGetPricings(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary List brokers and customers
     * @param {'health' | 'health_checkup'} [productType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerListBrokerCustomers(
      productType?: 'health' | 'health_checkup',
      options?: any,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<Array<BrokerCustomers>> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerListBrokerCustomers(productType, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Move an insured person to another package, or split them out
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerMoveProduct(
      body: MoveProductPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Order>> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerMoveProduct(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Dry-run moving an insured person to another package
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerPreviewMoveProduct(
      body: MoveProductPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<MoveProductPreview> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerPreviewMoveProduct(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Creates a new health checkup order and product based on the latest cancelled health checkup for the given account
     * @summary Recreate health checkup from cancelled product
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerRecreateHealthCheckup(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Batch remove owners from a company
     * @param {RemoveCompanyOwnersPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRemoveCompanyOwners(
      body: RemoveCompanyOwnersPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyResponse> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerRemoveCompanyOwners(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Save broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveBroker(
      body: Broker,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Broker> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerSaveBroker(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Save offer
     * @param {Offer} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveOffer(
      body: Offer,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Offer> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerSaveOffer(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Save pricing
     * @param {PricingPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSavePricing(
      body: PricingPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Pricing> {
      const localVarFetchArgs = AdminApiFetchParamCreator(
        configuration,
      ).adminControllerSavePricing(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Add person as company owner
     * @param {AddCompanyOwnerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAddCompanyOwner(
      body: AddCompanyOwnerPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerAddCompanyOwner(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Assign broker to account
     * @param {BrokerToAccountPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerAssignBrokerToAccount(
      body: BrokerToAccountPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerAssignBrokerToAccount(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     * Returns true if the account has a cancelled health checkup and no active/pending/inactive ones
     * @summary Check if health checkup can be recreated for an account
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerCanRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerCanRecreateHealthCheckup(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Change order payer
     * @param {ChangePayerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerChangePayer(body: ChangePayerPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerChangePayer(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Delete broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteBroker(body: Broker, options?: any) {
      return AdminApiFp(configuration).adminControllerDeleteBroker(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Delete offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerDeleteOffer(id: string, options?: any) {
      return AdminApiFp(configuration).adminControllerDeleteOffer(id, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Generate accounts report
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReport(body: AccountsReportPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerGenerateReport(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Export accounts as MIS Life XML
     * @param {MislifePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLife(body: MislifePayload, options?: any) {
      return AdminApiFp(configuration).adminControllerGenerateReportMISLife(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Export broker company accounts as MIS Life XML archive
     * @param {string} brokerCompanyId
     * @param {Array<string>} productTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportMISLifeArchive(
      brokerCompanyId: string,
      productTypes: Array<string>,
      options?: any,
    ) {
      return AdminApiFp(
        configuration,
      ).adminControllerGenerateReportMISLifeArchive(
        brokerCompanyId,
        productTypes,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Export accounts report as XLS
     * @param {AccountsReportPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGenerateReportXLS(
      body: AccountsReportPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerGenerateReportXLS(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary List all accounts data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetAccounts(options?: any) {
      return AdminApiFp(configuration).adminControllerGetAccounts(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary List all brokers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokers(options?: any) {
      return AdminApiFp(configuration).adminControllerGetBrokers(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get invite for brokers
     * @param {BrokerInvitePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetBrokersInvite(body: BrokerInvitePayload, options?: any) {
      return AdminApiFp(configuration).adminControllerGetBrokersInvite(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetChurn(body: MetricsPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerGetChurn(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary List all companies with owners and active product flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetCompanies(options?: any) {
      return AdminApiFp(configuration).adminControllerGetCompanies(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary List operational issues for admin review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetIssues(options?: any) {
      return AdminApiFp(configuration).adminControllerGetIssues(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @param {MetricsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMRR(body: MetricsPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerGetMRR(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetMonthlyLives(options?: any) {
      return AdminApiFp(configuration).adminControllerGetMonthlyLives(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetOffers(options?: any) {
      return AdminApiFp(configuration).adminControllerGetOffers(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get all pricings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerGetPricings(options?: any) {
      return AdminApiFp(configuration).adminControllerGetPricings(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary List brokers and customers
     * @param {'health' | 'health_checkup'} [productType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerListBrokerCustomers(
      productType?: 'health' | 'health_checkup',
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerListBrokerCustomers(
        productType,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Move an insured person to another package, or split them out
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerMoveProduct(body: MoveProductPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerMoveProduct(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Dry-run moving an insured person to another package
     * @param {MoveProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerPreviewMoveProduct(body: MoveProductPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerPreviewMoveProduct(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     * Creates a new health checkup order and product based on the latest cancelled health checkup for the given account
     * @summary Recreate health checkup from cancelled product
     * @param {RecreateHealthCheckupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRecreateHealthCheckup(
      body: RecreateHealthCheckupPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerRecreateHealthCheckup(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Batch remove owners from a company
     * @param {RemoveCompanyOwnersPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerRemoveCompanyOwners(
      body: RemoveCompanyOwnersPayload,
      options?: any,
    ) {
      return AdminApiFp(configuration).adminControllerRemoveCompanyOwners(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Save broker
     * @param {Broker} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveBroker(body: Broker, options?: any) {
      return AdminApiFp(configuration).adminControllerSaveBroker(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Save offer
     * @param {Offer} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSaveOffer(body: Offer, options?: any) {
      return AdminApiFp(configuration).adminControllerSaveOffer(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Save pricing
     * @param {PricingPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerSavePricing(body: PricingPayload, options?: any) {
      return AdminApiFp(configuration).adminControllerSavePricing(
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
  /**
   *
   * @summary Add person as company owner
   * @param {AddCompanyOwnerPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerAddCompanyOwner(
    body: AddCompanyOwnerPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerAddCompanyOwner(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Assign broker to account
   * @param {BrokerToAccountPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerAssignBrokerToAccount(
    body: BrokerToAccountPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerAssignBrokerToAccount(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   * Returns true if the account has a cancelled health checkup and no active/pending/inactive ones
   * @summary Check if health checkup can be recreated for an account
   * @param {RecreateHealthCheckupPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerCanRecreateHealthCheckup(
    body: RecreateHealthCheckupPayload,
    options?: any,
  ) {
    return AdminApiFp(
      this.configuration,
    ).adminControllerCanRecreateHealthCheckup(body, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Change order payer
   * @param {ChangePayerPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerChangePayer(body: ChangePayerPayload, options?: any) {
    return AdminApiFp(this.configuration).adminControllerChangePayer(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Delete broker
   * @param {Broker} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerDeleteBroker(body: Broker, options?: any) {
    return AdminApiFp(this.configuration).adminControllerDeleteBroker(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Delete offer
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerDeleteOffer(id: string, options?: any) {
    return AdminApiFp(this.configuration).adminControllerDeleteOffer(
      id,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Generate accounts report
   * @param {AccountsReportPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGenerateReport(
    body: AccountsReportPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerGenerateReport(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Export accounts as MIS Life XML
   * @param {MislifePayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGenerateReportMISLife(
    body: MislifePayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerGenerateReportMISLife(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Export broker company accounts as MIS Life XML archive
   * @param {string} brokerCompanyId
   * @param {Array<string>} productTypes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGenerateReportMISLifeArchive(
    brokerCompanyId: string,
    productTypes: Array<string>,
    options?: any,
  ) {
    return AdminApiFp(
      this.configuration,
    ).adminControllerGenerateReportMISLifeArchive(
      brokerCompanyId,
      productTypes,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Export accounts report as XLS
   * @param {AccountsReportPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGenerateReportXLS(
    body: AccountsReportPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerGenerateReportXLS(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary List all accounts data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetAccounts(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetAccounts(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary List all brokers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetBrokers(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetBrokers(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get invite for brokers
   * @param {BrokerInvitePayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetBrokersInvite(
    body: BrokerInvitePayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerGetBrokersInvite(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {MetricsPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetChurn(body: MetricsPayload, options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetChurn(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary List all companies with owners and active product flags
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetCompanies(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetCompanies(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary List operational issues for admin review
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetIssues(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetIssues(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @param {MetricsPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetMRR(body: MetricsPayload, options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetMRR(body, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetMonthlyLives(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetMonthlyLives(
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get offers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetOffers(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetOffers(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get all pricings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerGetPricings(options?: any) {
    return AdminApiFp(this.configuration).adminControllerGetPricings(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary List brokers and customers
   * @param {'health' | 'health_checkup'} [productType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerListBrokerCustomers(
    productType?: 'health' | 'health_checkup',
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerListBrokerCustomers(
      productType,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Move an insured person to another package, or split them out
   * @param {MoveProductPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerMoveProduct(body: MoveProductPayload, options?: any) {
    return AdminApiFp(this.configuration).adminControllerMoveProduct(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Dry-run moving an insured person to another package
   * @param {MoveProductPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerPreviewMoveProduct(
    body: MoveProductPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerPreviewMoveProduct(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   * Creates a new health checkup order and product based on the latest cancelled health checkup for the given account
   * @summary Recreate health checkup from cancelled product
   * @param {RecreateHealthCheckupPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerRecreateHealthCheckup(
    body: RecreateHealthCheckupPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerRecreateHealthCheckup(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Batch remove owners from a company
   * @param {RemoveCompanyOwnersPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerRemoveCompanyOwners(
    body: RemoveCompanyOwnersPayload,
    options?: any,
  ) {
    return AdminApiFp(this.configuration).adminControllerRemoveCompanyOwners(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Save broker
   * @param {Broker} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerSaveBroker(body: Broker, options?: any) {
    return AdminApiFp(this.configuration).adminControllerSaveBroker(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Save offer
   * @param {Offer} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerSaveOffer(body: Offer, options?: any) {
    return AdminApiFp(this.configuration).adminControllerSaveOffer(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Save pricing
   * @param {PricingPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerSavePricing(body: PricingPayload, options?: any) {
    return AdminApiFp(this.configuration).adminControllerSavePricing(
      body,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * AuthApi - fetch parameter creator
 * @export
 */
export const AuthApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Cancel BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCancel(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling authControllerCancel.',
        );
      }
      const localVarPath = `/auth/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Initiate BankID auth session
     * @param {AuthPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerStart(body: AuthPayload, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling authControllerStart.',
        );
      }
      const localVarPath = `/auth`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'AuthPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Verify status of BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerVerify(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling authControllerVerify.',
        );
      }
      const localVarPath = `/auth/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Cancel BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCancel(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthRequest> {
      const localVarFetchArgs = AuthApiFetchParamCreator(
        configuration,
      ).authControllerCancel(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Initiate BankID auth session
     * @param {AuthPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerStart(
      body: AuthPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthRequest> {
      const localVarFetchArgs = AuthApiFetchParamCreator(
        configuration,
      ).authControllerStart(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Verify status of BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerVerify(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthRequest> {
      const localVarFetchArgs = AuthApiFetchParamCreator(
        configuration,
      ).authControllerVerify(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Cancel BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCancel(id: string, options?: any) {
      return AuthApiFp(configuration).authControllerCancel(id, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Initiate BankID auth session
     * @param {AuthPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerStart(body: AuthPayload, options?: any) {
      return AuthApiFp(configuration).authControllerStart(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Verify status of BankID auth session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerVerify(id: string, options?: any) {
      return AuthApiFp(configuration).authControllerVerify(id, options)(
        fetch,
        basePath,
      );
    },
  };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   *
   * @summary Cancel BankID auth session
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authControllerCancel(id: string, options?: any) {
    return AuthApiFp(this.configuration).authControllerCancel(id, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Initiate BankID auth session
   * @param {AuthPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authControllerStart(body: AuthPayload, options?: any) {
    return AuthApiFp(this.configuration).authControllerStart(body, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Verify status of BankID auth session
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authControllerVerify(id: string, options?: any) {
    return AuthApiFp(this.configuration).authControllerVerify(id, options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * BankApi - fetch parameter creator
 * @export
 */
export const BankApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Check status and list of bank accounts
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerCheckFetching(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling bankControllerCheckFetching.',
        );
      }
      const localVarPath = `/bank/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Request auth to fetch bank accounts
     * @param {BankRequestPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerStartFetching(
      body: BankRequestPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling bankControllerStartFetching.',
        );
      }
      const localVarPath = `/bank`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'BankRequestPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BankApi - functional programming interface
 * @export
 */
export const BankApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Check status and list of bank accounts
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerCheckFetching(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BankRequest> {
      const localVarFetchArgs = BankApiFetchParamCreator(
        configuration,
      ).bankControllerCheckFetching(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Request auth to fetch bank accounts
     * @param {BankRequestPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerStartFetching(
      body: BankRequestPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<BankRequest> {
      const localVarFetchArgs = BankApiFetchParamCreator(
        configuration,
      ).bankControllerStartFetching(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * BankApi - factory interface
 * @export
 */
export const BankApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Check status and list of bank accounts
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerCheckFetching(id: string, options?: any) {
      return BankApiFp(configuration).bankControllerCheckFetching(id, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Request auth to fetch bank accounts
     * @param {BankRequestPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankControllerStartFetching(body: BankRequestPayload, options?: any) {
      return BankApiFp(configuration).bankControllerStartFetching(
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * BankApi - object-oriented interface
 * @export
 * @class BankApi
 * @extends {BaseAPI}
 */
export class BankApi extends BaseAPI {
  /**
   *
   * @summary Check status and list of bank accounts
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankApi
   */
  public bankControllerCheckFetching(id: string, options?: any) {
    return BankApiFp(this.configuration).bankControllerCheckFetching(
      id,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Request auth to fetch bank accounts
   * @param {BankRequestPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankApi
   */
  public bankControllerStartFetching(body: BankRequestPayload, options?: any) {
    return BankApiFp(this.configuration).bankControllerStartFetching(
      body,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * BrokerApi - fetch parameter creator
 * @export
 */
export const BrokerApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Register new broker
     * @param {BrokerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerControllerCreateBroker(
      body: BrokerPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling brokerControllerCreateBroker.',
        );
      }
      const localVarPath = `/broker`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'BrokerPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BrokerApi - functional programming interface
 * @export
 */
export const BrokerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Register new broker
     * @param {BrokerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerControllerCreateBroker(
      body: BrokerPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Broker> {
      const localVarFetchArgs = BrokerApiFetchParamCreator(
        configuration,
      ).brokerControllerCreateBroker(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * BrokerApi - factory interface
 * @export
 */
export const BrokerApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Register new broker
     * @param {BrokerPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerControllerCreateBroker(body: BrokerPayload, options?: any) {
      return BrokerApiFp(configuration).brokerControllerCreateBroker(
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * BrokerApi - object-oriented interface
 * @export
 * @class BrokerApi
 * @extends {BaseAPI}
 */
export class BrokerApi extends BaseAPI {
  /**
   *
   * @summary Register new broker
   * @param {BrokerPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BrokerApi
   */
  public brokerControllerCreateBroker(body: BrokerPayload, options?: any) {
    return BrokerApiFp(this.configuration).brokerControllerCreateBroker(
      body,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * DocumentApi - fetch parameter creator
 * @export
 */
export const DocumentApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Check if insurance agreement generated
     * @param {string} id
     * @param {string} product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerCheckAgreement(
      id: string,
      product: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling documentControllerCheckAgreement.',
        );
      }
      // verify required parameter 'product' is not null or undefined
      if (product === null || product === undefined) {
        throw new RequiredError(
          'product',
          'Required parameter product was null or undefined when calling documentControllerCheckAgreement.',
        );
      }
      const localVarPath = `/document/{id}/{product}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'product'}}`, encodeURIComponent(String(product)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get insurance agreement for relevant account and product
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetAgreement(
      id: string,
      related: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling documentControllerGetAgreement.',
        );
      }
      // verify required parameter 'related' is not null or undefined
      if (related === null || related === undefined) {
        throw new RequiredError(
          'related',
          'Required parameter related was null or undefined when calling documentControllerGetAgreement.',
        );
      }
      const localVarPath = `/document/{id}/{related}.pdf`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'related'}}`, encodeURIComponent(String(related)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get monthly report
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetMonthlyReport(
      id: string,
      related: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling documentControllerGetMonthlyReport.',
        );
      }
      // verify required parameter 'related' is not null or undefined
      if (related === null || related === undefined) {
        throw new RequiredError(
          'related',
          'Required parameter related was null or undefined when calling documentControllerGetMonthlyReport.',
        );
      }
      const localVarPath = `/document/broker/{related}/{id}.xls`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'related'}}`, encodeURIComponent(String(related)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get self-invoice PDF
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetSelfInvoicePDF(
      id: string,
      related: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling documentControllerGetSelfInvoicePDF.',
        );
      }
      // verify required parameter 'related' is not null or undefined
      if (related === null || related === undefined) {
        throw new RequiredError(
          'related',
          'Required parameter related was null or undefined when calling documentControllerGetSelfInvoicePDF.',
        );
      }
      const localVarPath = `/document/broker/{related}/{id}.pdf`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'related'}}`, encodeURIComponent(String(related)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Check if insurance agreement generated
     * @param {string} id
     * @param {string} product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerCheckAgreement(
      id: string,
      product: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = DocumentApiFetchParamCreator(
        configuration,
      ).documentControllerCheckAgreement(id, product, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get insurance agreement for relevant account and product
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetAgreement(
      id: string,
      related: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = DocumentApiFetchParamCreator(
        configuration,
      ).documentControllerGetAgreement(id, related, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get monthly report
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetMonthlyReport(
      id: string,
      related: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = DocumentApiFetchParamCreator(
        configuration,
      ).documentControllerGetMonthlyReport(id, related, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get self-invoice PDF
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetSelfInvoicePDF(
      id: string,
      related: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = DocumentApiFetchParamCreator(
        configuration,
      ).documentControllerGetSelfInvoicePDF(id, related, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Check if insurance agreement generated
     * @param {string} id
     * @param {string} product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerCheckAgreement(
      id: string,
      product: string,
      options?: any,
    ) {
      return DocumentApiFp(configuration).documentControllerCheckAgreement(
        id,
        product,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get insurance agreement for relevant account and product
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetAgreement(id: string, related: string, options?: any) {
      return DocumentApiFp(configuration).documentControllerGetAgreement(
        id,
        related,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get monthly report
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetMonthlyReport(
      id: string,
      related: string,
      options?: any,
    ) {
      return DocumentApiFp(configuration).documentControllerGetMonthlyReport(
        id,
        related,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get self-invoice PDF
     * @param {string} id
     * @param {string} related
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetSelfInvoicePDF(
      id: string,
      related: string,
      options?: any,
    ) {
      return DocumentApiFp(configuration).documentControllerGetSelfInvoicePDF(
        id,
        related,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
  /**
   *
   * @summary Check if insurance agreement generated
   * @param {string} id
   * @param {string} product
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public documentControllerCheckAgreement(
    id: string,
    product: string,
    options?: any,
  ) {
    return DocumentApiFp(this.configuration).documentControllerCheckAgreement(
      id,
      product,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get insurance agreement for relevant account and product
   * @param {string} id
   * @param {string} related
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public documentControllerGetAgreement(
    id: string,
    related: string,
    options?: any,
  ) {
    return DocumentApiFp(this.configuration).documentControllerGetAgreement(
      id,
      related,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get monthly report
   * @param {string} id
   * @param {string} related
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public documentControllerGetMonthlyReport(
    id: string,
    related: string,
    options?: any,
  ) {
    return DocumentApiFp(this.configuration).documentControllerGetMonthlyReport(
      id,
      related,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get self-invoice PDF
   * @param {string} id
   * @param {string} related
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public documentControllerGetSelfInvoicePDF(
    id: string,
    related: string,
    options?: any,
  ) {
    return DocumentApiFp(
      this.configuration,
    ).documentControllerGetSelfInvoicePDF(
      id,
      related,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * ERemissApi - fetch parameter creator
 * @export
 */
export const ERemissApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandleNotification(options: any = {}): FetchArgs {
      const localVarPath = `/e-remiss`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandlePostNotification(options: any = {}): FetchArgs {
      const localVarPath = `/e-remiss`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ERemissApi - functional programming interface
 * @export
 */
export const ERemissApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandleNotification(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        ERemissApiFetchParamCreator(
          configuration,
        ).eRemissControllerHandleNotification(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandlePostNotification(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        ERemissApiFetchParamCreator(
          configuration,
        ).eRemissControllerHandlePostNotification(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * ERemissApi - factory interface
 * @export
 */
export const ERemissApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandleNotification(options?: any) {
      return ERemissApiFp(configuration).eRemissControllerHandleNotification(
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eRemissControllerHandlePostNotification(options?: any) {
      return ERemissApiFp(
        configuration,
      ).eRemissControllerHandlePostNotification(options)(fetch, basePath);
    },
  };
};

/**
 * ERemissApi - object-oriented interface
 * @export
 * @class ERemissApi
 * @extends {BaseAPI}
 */
export class ERemissApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ERemissApi
   */
  public eRemissControllerHandleNotification(options?: any) {
    return ERemissApiFp(this.configuration).eRemissControllerHandleNotification(
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ERemissApi
   */
  public eRemissControllerHandlePostNotification(options?: any) {
    return ERemissApiFp(
      this.configuration,
    ).eRemissControllerHandlePostNotification(options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * GiddirApi - fetch parameter creator
 * @export
 */
export const GiddirApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {ModelObject} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    giddirControllerHandlePostNotification(
      body: ModelObject,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling giddirControllerHandlePostNotification.',
        );
      }
      const localVarPath = `/giddir`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'ModelObject' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GiddirApi - functional programming interface
 * @export
 */
export const GiddirApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ModelObject} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    giddirControllerHandlePostNotification(
      body: ModelObject,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = GiddirApiFetchParamCreator(
        configuration,
      ).giddirControllerHandlePostNotification(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * GiddirApi - factory interface
 * @export
 */
export const GiddirApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @param {ModelObject} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    giddirControllerHandlePostNotification(body: ModelObject, options?: any) {
      return GiddirApiFp(configuration).giddirControllerHandlePostNotification(
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * GiddirApi - object-oriented interface
 * @export
 * @class GiddirApi
 * @extends {BaseAPI}
 */
export class GiddirApi extends BaseAPI {
  /**
   *
   * @param {ModelObject} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiddirApi
   */
  public giddirControllerHandlePostNotification(
    body: ModelObject,
    options?: any,
  ) {
    return GiddirApiFp(
      this.configuration,
    ).giddirControllerHandlePostNotification(body, options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * OrderApi - fetch parameter creator
 * @export
 */
export const OrderApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Add new person to order
     * @param {string} id
     * @param {Person} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddPerson(
      id: string,
      body: Person,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerAddPerson.',
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerAddPerson.',
        );
      }
      const localVarPath = `/order/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'PATCH' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'Person' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Add new product to order
     * @param {string} id
     * @param {ProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddProduct(
      id: string,
      body: ProductPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerAddProduct.',
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerAddProduct.',
        );
      }
      const localVarPath = `/order/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'ProductPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Cancel product
     * @param {string} id
     * @param {string} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCancelProduct(
      id: string,
      note: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerCancelProduct.',
        );
      }
      // verify required parameter 'note' is not null or undefined
      if (note === null || note === undefined) {
        throw new RequiredError(
          'note',
          'Required parameter note was null or undefined when calling orderControllerCancelProduct.',
        );
      }
      const localVarPath = `/order/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options,
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (note !== undefined) {
        localVarQueryParameter['note'] = note;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create new order for current account
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCreate(
      body: OrderOptionsPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerCreate.',
        );
      }
      const localVarPath = `/order`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'OrderOptionsPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get specific offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetOffer(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerGetOffer.',
        );
      }
      const localVarPath = `/order/offer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get latest pricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricing(options: any = {}): FetchArgs {
      const localVarPath = `/order/pricing`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get specific pricing
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricingById(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerGetPricingById.',
        );
      }
      const localVarPath = `/order/pricing/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create new order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiCreate(
      body: OrderPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerMultiCreate.',
        );
      }
      const localVarPath = `/order`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'OrderPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Preview order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiPreview(
      body: OrderPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerMultiPreview.',
        );
      }
      const localVarPath = `/order/preview`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'OrderPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Preview order for product
     * @param {string} productType
     * @param {number} paymentPeriod
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerPreview(
      productType: string,
      paymentPeriod: number,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'productType' is not null or undefined
      if (productType === null || productType === undefined) {
        throw new RequiredError(
          'productType',
          'Required parameter productType was null or undefined when calling orderControllerPreview.',
        );
      }
      // verify required parameter 'paymentPeriod' is not null or undefined
      if (paymentPeriod === null || paymentPeriod === undefined) {
        throw new RequiredError(
          'paymentPeriod',
          'Required parameter paymentPeriod was null or undefined when calling orderControllerPreview.',
        );
      }
      const localVarPath = `/order/preview`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (productType !== undefined) {
        localVarQueryParameter['productType'] = productType;
      }

      if (paymentPeriod !== undefined) {
        localVarQueryParameter['paymentPeriod'] = paymentPeriod;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update order options
     * @param {string} id
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerUpdateOrder(
      id: string,
      body: OrderOptionsPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling orderControllerUpdateOrder.',
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling orderControllerUpdateOrder.',
        );
      }
      const localVarPath = `/order/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'OrderOptionsPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add new person to order
     * @param {string} id
     * @param {Person} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddPerson(
      id: string,
      body: Person,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Product> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerAddPerson(id, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Add new product to order
     * @param {string} id
     * @param {ProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddProduct(
      id: string,
      body: ProductPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Product> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerAddProduct(id, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Cancel product
     * @param {string} id
     * @param {string} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCancelProduct(
      id: string,
      note: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerCancelProduct(id, note, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Create new order for current account
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCreate(
      body: OrderOptionsPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerCreate(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get specific offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetOffer(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<OrderPayload> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerGetOffer(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get latest pricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricing(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Pricing> {
      const localVarFetchArgs =
        OrderApiFetchParamCreator(configuration).orderControllerGetPricing(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get specific pricing
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricingById(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Pricing> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerGetPricingById(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Create new order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiCreate(
      body: OrderPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerMultiCreate(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Preview order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiPreview(
      body: OrderPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerMultiPreview(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Preview order for product
     * @param {string} productType
     * @param {number} paymentPeriod
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerPreview(
      productType: string,
      paymentPeriod: number,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Order> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerPreview(productType, paymentPeriod, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Update order options
     * @param {string} id
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerUpdateOrder(
      id: string,
      body: OrderOptionsPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = OrderApiFetchParamCreator(
        configuration,
      ).orderControllerUpdateOrder(id, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Add new person to order
     * @param {string} id
     * @param {Person} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddPerson(id: string, body: Person, options?: any) {
      return OrderApiFp(configuration).orderControllerAddPerson(
        id,
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Add new product to order
     * @param {string} id
     * @param {ProductPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerAddProduct(id: string, body: ProductPayload, options?: any) {
      return OrderApiFp(configuration).orderControllerAddProduct(
        id,
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Cancel product
     * @param {string} id
     * @param {string} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCancelProduct(id: string, note: string, options?: any) {
      return OrderApiFp(configuration).orderControllerCancelProduct(
        id,
        note,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Create new order for current account
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerCreate(body: OrderOptionsPayload, options?: any) {
      return OrderApiFp(configuration).orderControllerCreate(body, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get specific offer
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetOffer(id: string, options?: any) {
      return OrderApiFp(configuration).orderControllerGetOffer(id, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get latest pricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricing(options?: any) {
      return OrderApiFp(configuration).orderControllerGetPricing(options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Get specific pricing
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerGetPricingById(id: string, options?: any) {
      return OrderApiFp(configuration).orderControllerGetPricingById(
        id,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Create new order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiCreate(body: OrderPayload, options?: any) {
      return OrderApiFp(configuration).orderControllerMultiCreate(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Preview order for multiple products
     * @param {OrderPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerMultiPreview(body: OrderPayload, options?: any) {
      return OrderApiFp(configuration).orderControllerMultiPreview(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Preview order for product
     * @param {string} productType
     * @param {number} paymentPeriod
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerPreview(
      productType: string,
      paymentPeriod: number,
      options?: any,
    ) {
      return OrderApiFp(configuration).orderControllerPreview(
        productType,
        paymentPeriod,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Update order options
     * @param {string} id
     * @param {OrderOptionsPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderControllerUpdateOrder(
      id: string,
      body: OrderOptionsPayload,
      options?: any,
    ) {
      return OrderApiFp(configuration).orderControllerUpdateOrder(
        id,
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
  /**
   *
   * @summary Add new person to order
   * @param {string} id
   * @param {Person} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerAddPerson(id: string, body: Person, options?: any) {
    return OrderApiFp(this.configuration).orderControllerAddPerson(
      id,
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Add new product to order
   * @param {string} id
   * @param {ProductPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerAddProduct(
    id: string,
    body: ProductPayload,
    options?: any,
  ) {
    return OrderApiFp(this.configuration).orderControllerAddProduct(
      id,
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Cancel product
   * @param {string} id
   * @param {string} note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerCancelProduct(id: string, note: string, options?: any) {
    return OrderApiFp(this.configuration).orderControllerCancelProduct(
      id,
      note,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Create new order for current account
   * @param {OrderOptionsPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerCreate(body: OrderOptionsPayload, options?: any) {
    return OrderApiFp(this.configuration).orderControllerCreate(body, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get specific offer
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerGetOffer(id: string, options?: any) {
    return OrderApiFp(this.configuration).orderControllerGetOffer(id, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get latest pricing
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerGetPricing(options?: any) {
    return OrderApiFp(this.configuration).orderControllerGetPricing(options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get specific pricing
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerGetPricingById(id: string, options?: any) {
    return OrderApiFp(this.configuration).orderControllerGetPricingById(
      id,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Create new order for multiple products
   * @param {OrderPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerMultiCreate(body: OrderPayload, options?: any) {
    return OrderApiFp(this.configuration).orderControllerMultiCreate(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Preview order for multiple products
   * @param {OrderPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerMultiPreview(body: OrderPayload, options?: any) {
    return OrderApiFp(this.configuration).orderControllerMultiPreview(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Preview order for product
   * @param {string} productType
   * @param {number} paymentPeriod
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerPreview(
    productType: string,
    paymentPeriod: number,
    options?: any,
  ) {
    return OrderApiFp(this.configuration).orderControllerPreview(
      productType,
      paymentPeriod,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Update order options
   * @param {string} id
   * @param {OrderOptionsPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */
  public orderControllerUpdateOrder(
    id: string,
    body: OrderOptionsPayload,
    options?: any,
  ) {
    return OrderApiFp(this.configuration).orderControllerUpdateOrder(
      id,
      body,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * PaymentApi - fetch parameter creator
 * @export
 */
export const PaymentApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Connect new payment method
     * @param {PaymentPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerConnectPaymentMethod(
      body: PaymentPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling paymentControllerConnectPaymentMethod.',
        );
      }
      const localVarPath = `/payment`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'PaymentPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Toggle payment method
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerTogglePaymentMethod(
      id: string,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling paymentControllerTogglePaymentMethod.',
        );
      }
      const localVarPath = `/payment/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Connect new payment method
     * @param {PaymentPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerConnectPaymentMethod(
      body: PaymentPayload,
      options?: any,
    ): (
      fetch?: FetchAPI,
      basePath?: string,
    ) => Promise<ConnectPaymentResponse> {
      const localVarFetchArgs = PaymentApiFetchParamCreator(
        configuration,
      ).paymentControllerConnectPaymentMethod(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Toggle payment method
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerTogglePaymentMethod(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = PaymentApiFetchParamCreator(
        configuration,
      ).paymentControllerTogglePaymentMethod(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Connect new payment method
     * @param {PaymentPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerConnectPaymentMethod(body: PaymentPayload, options?: any) {
      return PaymentApiFp(configuration).paymentControllerConnectPaymentMethod(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Toggle payment method
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerTogglePaymentMethod(id: string, options?: any) {
      return PaymentApiFp(configuration).paymentControllerTogglePaymentMethod(
        id,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
  /**
   *
   * @summary Connect new payment method
   * @param {PaymentPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerConnectPaymentMethod(
    body: PaymentPayload,
    options?: any,
  ) {
    return PaymentApiFp(
      this.configuration,
    ).paymentControllerConnectPaymentMethod(body, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Toggle payment method
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerTogglePaymentMethod(id: string, options?: any) {
    return PaymentApiFp(
      this.configuration,
    ).paymentControllerTogglePaymentMethod(id, options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * ProductApi - fetch parameter creator
 * @export
 */
export const ProductApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productControllerGetLabs(options: any = {}): FetchArgs {
      const localVarPath = `/product/labs`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productControllerGetLabs(
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Lab>> {
      const localVarFetchArgs =
        ProductApiFetchParamCreator(configuration).productControllerGetLabs(
          options,
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productControllerGetLabs(options?: any) {
      return ProductApiFp(configuration).productControllerGetLabs(options)(
        fetch,
        basePath,
      );
    },
  };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductApi
   */
  public productControllerGetLabs(options?: any) {
    return ProductApiFp(this.configuration).productControllerGetLabs(options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * QuizApi - fetch parameter creator
 * @export
 */
export const QuizApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get quiz created within 30 days
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerGet(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling quizControllerGet.',
        );
      }
      const localVarPath = `/quiz/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite customer to complete the health quiz
     * @param {string} id
     * @param {QuizInvite} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerInvite(
      id: string,
      body: QuizInvite,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling quizControllerInvite.',
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling quizControllerInvite.',
        );
      }
      const localVarPath = `/quiz/{id}/invite`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'QuizInvite' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save quiz answers and get available product types
     * @param {boolean} complete
     * @param {Quiz} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerSave(
      complete: boolean,
      body: Quiz,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'complete' is not null or undefined
      if (complete === null || complete === undefined) {
        throw new RequiredError(
          'complete',
          'Required parameter complete was null or undefined when calling quizControllerSave.',
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling quizControllerSave.',
        );
      }
      const localVarPath = `/quiz`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (complete !== undefined) {
        localVarQueryParameter['complete'] = complete;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'Quiz' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuizApi - functional programming interface
 * @export
 */
export const QuizApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get quiz created within 30 days
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerGet(
      id: string,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Quiz> {
      const localVarFetchArgs = QuizApiFetchParamCreator(
        configuration,
      ).quizControllerGet(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Invite customer to complete the health quiz
     * @param {string} id
     * @param {QuizInvite} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerInvite(
      id: string,
      body: QuizInvite,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = QuizApiFetchParamCreator(
        configuration,
      ).quizControllerInvite(id, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Save quiz answers and get available product types
     * @param {boolean} complete
     * @param {Quiz} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerSave(
      complete: boolean,
      body: Quiz,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Quiz> {
      const localVarFetchArgs = QuizApiFetchParamCreator(
        configuration,
      ).quizControllerSave(complete, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * QuizApi - factory interface
 * @export
 */
export const QuizApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Get quiz created within 30 days
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerGet(id: string, options?: any) {
      return QuizApiFp(configuration).quizControllerGet(id, options)(
        fetch,
        basePath,
      );
    },
    /**
     *
     * @summary Invite customer to complete the health quiz
     * @param {string} id
     * @param {QuizInvite} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerInvite(id: string, body: QuizInvite, options?: any) {
      return QuizApiFp(configuration).quizControllerInvite(
        id,
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Save quiz answers and get available product types
     * @param {boolean} complete
     * @param {Quiz} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quizControllerSave(complete: boolean, body: Quiz, options?: any) {
      return QuizApiFp(configuration).quizControllerSave(
        complete,
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * QuizApi - object-oriented interface
 * @export
 * @class QuizApi
 * @extends {BaseAPI}
 */
export class QuizApi extends BaseAPI {
  /**
   *
   * @summary Get quiz created within 30 days
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuizApi
   */
  public quizControllerGet(id: string, options?: any) {
    return QuizApiFp(this.configuration).quizControllerGet(id, options)(
      this.fetch,
      this.basePath,
    );
  }

  /**
   *
   * @summary Invite customer to complete the health quiz
   * @param {string} id
   * @param {QuizInvite} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuizApi
   */
  public quizControllerInvite(id: string, body: QuizInvite, options?: any) {
    return QuizApiFp(this.configuration).quizControllerInvite(
      id,
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Save quiz answers and get available product types
   * @param {boolean} complete
   * @param {Quiz} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuizApi
   */
  public quizControllerSave(complete: boolean, body: Quiz, options?: any) {
    return QuizApiFp(this.configuration).quizControllerSave(
      complete,
      body,
      options,
    )(this.fetch, this.basePath);
  }
}

/**
 * SensitiveApi - fetch parameter creator
 * @export
 */
export const SensitiveApiFetchParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Look up sensitive details
     * @param {SensitiveLookupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerLookup(
      body: SensitiveLookupPayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling sensitiveControllerLookup.',
        );
      }
      const localVarPath = `/sensitive`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'SensitiveLookupPayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update sensitive details
     * @param {SensitiveUpdatePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerUpdateDetails(
      body: SensitiveUpdatePayload,
      options: any = {},
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling sensitiveControllerUpdateDetails.',
        );
      }
      const localVarPath = `/sensitive`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers,
      );
      const needsSerialization =
        'SensitiveUpdatePayload' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || '';

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SensitiveApi - functional programming interface
 * @export
 */
export const SensitiveApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Look up sensitive details
     * @param {SensitiveLookupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerLookup(
      body: SensitiveLookupPayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Sensitive> {
      const localVarFetchArgs = SensitiveApiFetchParamCreator(
        configuration,
      ).sensitiveControllerLookup(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Update sensitive details
     * @param {SensitiveUpdatePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerUpdateDetails(
      body: SensitiveUpdatePayload,
      options?: any,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = SensitiveApiFetchParamCreator(
        configuration,
      ).sensitiveControllerUpdateDetails(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH,
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * SensitiveApi - factory interface
 * @export
 */
export const SensitiveApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string,
) {
  return {
    /**
     *
     * @summary Look up sensitive details
     * @param {SensitiveLookupPayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerLookup(body: SensitiveLookupPayload, options?: any) {
      return SensitiveApiFp(configuration).sensitiveControllerLookup(
        body,
        options,
      )(fetch, basePath);
    },
    /**
     *
     * @summary Update sensitive details
     * @param {SensitiveUpdatePayload} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensitiveControllerUpdateDetails(
      body: SensitiveUpdatePayload,
      options?: any,
    ) {
      return SensitiveApiFp(configuration).sensitiveControllerUpdateDetails(
        body,
        options,
      )(fetch, basePath);
    },
  };
};

/**
 * SensitiveApi - object-oriented interface
 * @export
 * @class SensitiveApi
 * @extends {BaseAPI}
 */
export class SensitiveApi extends BaseAPI {
  /**
   *
   * @summary Look up sensitive details
   * @param {SensitiveLookupPayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensitiveApi
   */
  public sensitiveControllerLookup(
    body: SensitiveLookupPayload,
    options?: any,
  ) {
    return SensitiveApiFp(this.configuration).sensitiveControllerLookup(
      body,
      options,
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Update sensitive details
   * @param {SensitiveUpdatePayload} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensitiveApi
   */
  public sensitiveControllerUpdateDetails(
    body: SensitiveUpdatePayload,
    options?: any,
  ) {
    return SensitiveApiFp(this.configuration).sensitiveControllerUpdateDetails(
      body,
      options,
    )(this.fetch, this.basePath);
  }
}
